import React, {Component} from 'react';
import {Row, Col, UncontrolledCollapse, Button, Card, CardBody, Collapse} from "reactstrap";
import './FAQ.scss'
// import minIcon from '../../assets/img/revamp/logo/min-logo.png'
// import plusIcon from '../../assets/img/revamp/logo/plus-logo.png'
import minIcon from '../../assets/img/revamp/vibernets/icons8-minus-24.png'
import plusIcon from '../../assets/img/revamp/vibernets/icons8-sum-32.png'
import Collapsible from "react-collapsible";

class FAQ extends Component {

    state = {
        collapse: false,
        selectedQuestion: ''
    };


    onEntering = () => this.setState('Opening...');
    onEntered = () => this.setState('Opened');
    onExiting = () => this.setState('Closing...');
    onExited = () => this.setState('Closed');
    toggle = (index) => {
        let qIndex = this.state.selectedQuestion === index ? '' : index;
        this.setState({collapse: !this.state.collapse, selectedQuestion: qIndex});
    }

    render() {
        let {desc, faq, descSin} = this.props;
        let {collapse, selectedQuestion} = this.state;
        return (
            <div id={'FAQ'} className="container FAQ pt-3 pb-6">
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <div className='text-center'>
                            <h1 className='main-topic'>
                                FAQ
                            </h1>
                            <p className='sub-desc py-3 mb-0'>{desc}</p>
                            {/*{descSin && <p className={'sub-desc py-3'}>{descSin}</p>}*/}
                        </div>
                    </Col>
                </Row>

                <Row className='d-flex justify-content-center'>
                    {faq.map((body, index) =>
                        <Col className='FAQ-holder' sm={12} md={12} lg={8}>
                            <div key={index * 5 + 'faq'}>


                                <Collapsible trigger={<span>     <div
                                    className='Q-holder d-flex align-items-center justify-content-between'
                                    onClick={() => this.toggle(index)}

                                >
                                    {body.question} {index === selectedQuestion ? <img style={{cursor:'pointer'}} src={minIcon} alt=""/> :
                                    <img style={{width:24,height:24,cursor:'pointer'}} src={plusIcon} alt=""/>
                                }
                                </div>
                                </span>}>
                                    {/*<p>*/}
                                        {
                                            body.answer
                                        }
                                        {/*<br/>*/}
                                        {
                                            body?.answer2 && <p className={'answer-para'}>{body?.answer2}<br/></p>
                                        }
                                        {
                                            body?.answer15 && <p className={'answer-para'}>{body?.answer15}<br/></p>
                                        }
                                        {
                                            body?.answer16 && <p className={'answer-para'}>{body?.answer16}<br/></p>
                                        }
                                        {
                                            body?.answer17 && <p className={'answer-para'}>{body?.answer17}<br/></p>
                                        }
                                        {
                                            body?.answer18 && <p className={'answer-para'}>{body?.answer18}<br/></p>
                                        }
                                        {
                                            body?.answer19 && <p className={'answer-para'}>{body?.answer19}<br/></p>
                                        }
                                    {(body?.answer3 || body?.answer13 || body?.answer14 || body?.answer4 || body?.answer22 || body?.answer23) ? <br/> : null}
                                        {
                                            body?.answer3 && <p className={'answer-para'}>{body?.answer3} <br/></p>
                                        }
                                        {
                                            body?.answer13 && <p className={'answer-para'}>{body?.answer13}<br/></p>
                                        }
                                        {
                                            body?.answer14 && <p className={'answer-para'}>{body?.answer14}<br/></p>
                                        }
                                        {
                                            body?.answer4 && <p className={'answer-para'}> {body?.answer4}<br/></p>
                                        }
                                        {
                                            body?.answer22 && <p className={'answer-para'}>{body?.answer22}<br/></p>
                                        }
                                        {
                                            body?.answer23 && <p className={'answer-para'}>{body?.answer23}<br/></p>
                                        }
                                    {(body?.answer5 || body?.answer6) ? <br/> : null}
                                        {
                                            body?.answer5 && <p className={'answer-para'}> {body?.answer5} <br/></p>
                                        }
                                        {
                                            body?.answer6 && <p className={'answer-para'}>{body?.answer6}<br/></p>
                                        }
                                    {(body?.answer7 || body?.answer8) ? <br/> : null}
                                        {
                                            body?.answer7 && <p className={'answer-para'}>{body?.answer7}<br/></p>
                                        }
                                        {
                                            body?.answer8 && <p className={'answer-para'}>{body?.answer8}<br/></p>
                                        }
                                    {(body?.answer9 || body?.answer10) ? <br/> : null}
                                        {
                                            body?.answer9 && <p className={'answer-para'}>{body?.answer9}<br/></p>
                                        }
                                        {
                                            body?.answer10 && <p className={'answer-para'}>{body?.answer10}<br/></p>
                                        }
                                    {(body?.answer11 || body?.answer12) ? <br/> : null}
                                        {
                                            body?.answer11 && <p className={'answer-para'}>{body?.answer11}<br/></p>
                                        }
                                        {
                                            body?.answer12 && <p className={'answer-para'}>{body?.answer12}<br/></p>
                                        }
                                    {/*</p>*/}

                                </Collapsible>
                            </div>
                        </Col>
                    )}
                </Row>

            </div>
        )
    }
}

export default FAQ;
